import { useSelector, useDispatch } from 'react-redux'
import { FileDropZone } from '../../../../components/forms/dropzone/fileDropZone.type'
import { FormDropZone } from '../../../../components/forms/dropzone/FormDropZone'
import { RootState } from '../../../../redux'
import {
  useEliminarReportePorIdMutation,
  useRecuperarReportesPorIdRelacionadoMutation,
} from '../../../../redux/api/reportesCumplimiento.api'
import { cargarReportes } from '../../../../redux/slices/reportes'
import toast from 'react-hot-toast'
import { useEffect } from 'react'
import { Reporte } from '../../../../models'


type Props = {
  arrArchivos: FileDropZone[]
  setArrArchivos: (arg: FileDropZone[]) => void
  idRelacionado: string
  height?: number
  width?: string
  heightMaxScroll?: number
  textoTipoArchivo?: string
  ocultarAcciones?: boolean
  usuarioPermisoCrear?: boolean
}

export const ReportesCumplimiento = ({
  arrArchivos,
  setArrArchivos,
  idRelacionado,
  height,
  width,
  heightMaxScroll,
  textoTipoArchivo,
  ocultarAcciones,
  usuarioPermisoCrear = true,
}: Props) => {
  // Componente compartido de evidencia documental.
  // Fuente de verdad de archivos existentes: redux `state.reportes`.
  // `arrArchivos` contiene archivos seleccionados en UI (nuevos) y se limpia despues de guardar/eliminar.
  // Nota: la subida (FormData) ocurre en el contenedor (por ejemplo modal de condicionante/tarea).
  const dispatch = useDispatch()
  const recuperaReportes = useSelector((state: RootState) => state.reportes)
  const tamanioArrayReportes = recuperaReportes.reportes.length

  const arrArchivosExistentes = recuperaReportes.reportes.map((r: Reporte) => {
    // Adaptacion Reporte -> FileDropZone para renderizar en FormDropZone.
    return {
      id: r.idReporte,
      name: r.nombre,
      isNew: false,
      ext: r.nombre?.split('.').pop(),
      url: r.ruta,
    }
  }) as []

  const style = {
    borderRadius: '10px',
    background: '#333',
    color: '#fff',
    fontSize: '18px',
  }
  const [recuperarReportes, { isSuccess }] = useRecuperarReportesPorIdRelacionadoMutation()
  const [eliminarReportePorId] = useEliminarReportePorIdMutation()

  useEffect(() => {
    // Si no hay refetch exitoso, se limpia la lista para evitar mostrar evidencia obsoleta.
    if (!isSuccess) {
      dispatch(cargarReportes([]))
    }
  }, [isSuccess])
  /**
   * @description Elimna un reporte guardado o recién cargado por medio
   *              de su id o index
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 13/01/2023
   * @param idReporteCumplimiento id del reporte
   */
  const eliminarReporteCumplimiento = (idReporteCumplimiento: string) => {
    // Elimina evidencia persistida; al terminar se refetch la lista del relacionado.
    const toastId = toast.loading('Eliminando reporte', { style })
    eliminarReportePorId(idReporteCumplimiento)
      .unwrap()
      .then(() => {
        recuperarReportes(idRelacionado)
          .unwrap()
          .then((resp: Reporte[]) => {
            const arrArchivos = resp.filter((r: FileDropZone) => r.id !== idReporteCumplimiento)
            dispatch(cargarReportes(arrArchivos))
            setArrArchivos([])
          })
          .catch(console.error)
        toast.success('¡Reporte eliminado!', {
          id: toastId,
          style,
        })
      })
      .catch((err) => {
        toast.error('¡Error al eliminar el reporte!', {
          id: toastId,
          style,
        })
        console.error(err)
      })
  }
  const modoCrear = usuarioPermisoCrear
  const existenArchivosGuardados = tamanioArrayReportes > 0 ?? false
  const savedFiles = modoCrear ? true : existenArchivosGuardados
  return (
    <div className='col-12'>
      {!usuarioPermisoCrear && tamanioArrayReportes === 0 ? (
        <div
          className='col-12 align-items-between d-flex flex-column justify-content-center'
          style={{ height: '15vh' }}>
          <div className='d-flex flex-column justify-content-center'>
            <i className='d-flex justify-content-center bi bi-file-earmark font-size-icon'></i>
            <i className='d-flex justify-content-center fs-4 pt-2'>Sin documentos para mostrar</i>
          </div>
        </div>
      ) : (
        <div className='col-12'>
          <FormDropZone
            arrAcceptedFiles={arrArchivos}
            arrExistsFiles={arrArchivosExistentes}
            setArrAcceptedFiles={setArrArchivos}
            fnDeleteExistFile={eliminarReporteCumplimiento}
            height={height}
            width={width}
            heightMaxScroll={heightMaxScroll}
            textTypeFile={textoTipoArchivo}
            isVisuallyHidden={ocultarAcciones}
            savedFiles={savedFiles}
            creationMode={usuarioPermisoCrear}></FormDropZone>
        </div>
      )}
    </div>
  )
}
